import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import Translation from '../../../../../../common/components/translation/Translation';
import variantSpecificationsSelectors from '../../../../../store/selectors/variantSpecificationsSelectors';
import SpecificationsAndFeaturesLoader from '../../../../presentational/loaders/SpecificationsAndFeaturesLoader';
import SpecificationsDetailList from './specificationsDetailList/SpecificationsDetailList';

const TechnicalSpecificationsContainer: FunctionComponent = () => {
  const technicalSpecifications = useSelector(variantSpecificationsSelectors.getTechnicalSpecifications);
  const specificationsLoading = useSelector(variantSpecificationsSelectors.getLoadingStatus);

  if (specificationsLoading || !technicalSpecifications) {
    return <SpecificationsAndFeaturesLoader />;
  }

  return (
    <SpecificationsDetailList
      title={<Translation id="spc.customise.technicalSpecifications.title" />}
      variantFeatures={technicalSpecifications}
    />
  );
};

export default TechnicalSpecificationsContainer;
